import { render, staticRenderFns } from "./UnitType.vue?vue&type=template&id=2a15f762&scoped=true&"
import script from "./UnitType.vue?vue&type=script&lang=js&"
export * from "./UnitType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a15f762",
  null
  
)

export default component.exports